import $ from 'jquery';
import Glider from 'glider-js';

export const init = () => {
	const jsCompany = $('.js-company');

	const hash = window.location.hash.substr(1);
	jsCompany.find('.company__tab').addClass('company__tab--hidden');
	$(`[data-tab-id="${hash || 'loc-1'}"]`).removeClass('company__tab--hidden');
	const text = jsCompany.find('#company-select').parent().find(`[data-tab='${hash}']`).text();

	jsCompany.find('.company__tab').each(function (index, el) {
		if (!el.classList.contains('company__tab--hidden')) {
			const btnText = $('.js-btn-text');
			const selectedItem = $('.dropdown__item--selected');

			btnText.html(selectedItem.text());
		}
		return;
	});

	if (hash) jsCompany.find('#company-select').parent().find('.js-btn-text').text(text);

	const initCarousel = () => {
		const jsCompanyCarousel = document.querySelectorAll('.company__tab:not(.company__tab--hidden) .js-company-carousel');
		Array.from(jsCompanyCarousel).forEach((item) => {
			const prevControl = item.nextElementSibling.querySelector('.slider-control__arrow-prev');
			const nextControl = item.nextElementSibling.querySelector('.slider-control__arrow-next');

			new Glider(item, {
				slidesToShow: 1,
				slidesToScroll: 1,
				draggable: true,
				duration: 0.3,
				arrows: {
					prev: prevControl,
					next: nextControl,
				},
				responsive: [
					{
						draggable: false,
						breakpoint: 750,
						settings: {
							slidesToScroll: 'auto',
						},
					},
				],
			});
			if (item.querySelectorAll('.company__item').length < 2) {
				item.parentElement.querySelector('.slider-control').classList.add('u-hide');
			}
		});
	};

	jsCompany.find('.js-dropdown .js-dropdown-item').on('click', (e) => {
		const value = $(e.target).parent().data('tab');
		jsCompany.find('.company__tab').removeClass('company__tab--hidden');
		jsCompany.find('.company__tab').addClass('company__tab--hidden');
		$(`[data-tab-id="${value}"]`).removeClass('company__tab--hidden');
		window.location.hash = value;
		initCarousel();
	});

	initCarousel();
};
